import { GetListResponse } from "@app/types";
import { SettingUi, UpdateSettingUiRequest } from "@app/types/setting-ui.type";
import HttpService from "@core/services/http/http.service";
import {
  RequestContentType,
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _SettingUiService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<SettingUi>>(
      "/admin/api/v2/setting-ui",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public update(
    settingUiId: number,
    updateSettingUiRequest: UpdateSettingUiRequest
  ) {
    return HttpService.patch(`/admin/api/v2/setting-ui/${settingUiId}`, {
      body: { ...updateSettingUiRequest },
      requestContentType: RequestContentType.MULTIPART,
    });
  }
}

const SettingUiService = new _SettingUiService();

export default SettingUiService;
